import { render } from "./dbfx.vue?vue&type=template&id=7533ab74&scoped=true&ts=true"
import script from "./dbfx.vue?vue&type=script&lang=ts"
export * from "./dbfx.vue?vue&type=script&lang=ts"

import "./dbfx.vue?vue&type=style&index=0&id=7533ab74&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7533ab74"]])

export default __exports__